/**
 * mc-tracking.js — Manifesto · task 0033
 *
 * Página "Rastreie seu Pedido" (main-tracking-manifesto.liquid).
 * Vanilla JS, IIFE, sem libs. Estados E-1..E-14 do gate /ui-ux (0033-f0):
 * filtro numérico + habilitação AJ-6 (14 dígitos + token Turnstile), widget
 * Turnstile em render explícito (inserido AQUI, não no Liquid — CookieYes
 * gerencia e o timeout de 8s tem um único ponto, E-8), consulta single-flight
 * à Edge Function jadlog-tracking, timeline de 5 passos (AJ-7) com stagger
 * sensível a prefers-reduced-motion (AJ-9), live region persistente (AJ-8),
 * telemetria order_tracking_search SEM o código de rastreio (DP-11).
 *
 * E-17 — deep link `?cod=<código>` (alias `?codigo=`), usado no e-mail de
 * "pedido enviado": prefill sanitizado + auto-consulta zero-clique quando o
 * token do Turnstile chega (o clique no link JÁ é a intenção de consultar).
 * Guardas: param incompleto = prefill parcial + erro inline E-2 sem auto-run;
 * edição manual cancela o auto-run; one-shot por page load; "Rastrear outro
 * pedido" remove o param via replaceState. O captcha continua OBRIGATÓRIO.
 *
 * Dados vindos da API (eventos crus, status, previsão) entram no DOM SEMPRE
 * via textContent — nunca innerHTML (dado externo, XSS).
 */
(function () {
  'use strict';

  /* Constante única do tamanho do código (AJ-6) — range definitivo
     condicionado ao spike C-4; mudar aqui muda filtro, guarda e mensagem. */
  var CODE_LEN = 14;

  var TS_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=mcTrackTsOnload';
  var TS_TIMEOUT_MS = 8000; /* E-8 */
  var FETCH_TIMEOUT_MS = 15000;

  /* AJ-7 — passos fixos da timeline */
  var STEPS = ['Despachado', 'Coletado pela Jadlog', 'Em trânsito', 'Saiu para entrega', 'Entregue'];
  /* Índice do passo atual derivado do status NORMALIZADO do topo da resposta */
  var STATUS_STEP = {
    confirmed: 1,
    collected: 2,
    in_transit: 3,
    out_for_delivery: 4,
    delivered: 5
  };

  var CHECK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  var STR = {
    inputError: 'O código tem ' + CODE_LEN + ' dígitos — confira no e-mail de envio.', /* f-3 */
    loading: 'Consultando a Jadlog…', /* f-4 */
    captchaExpired: 'A verificação de segurança expirou — confirme de novo para rastrear.', /* f-12 / E-6 */
    captchaError: 'Não foi possível concluir a verificação de segurança. Tente de novo.', /* E-7 */
    captchaFailed: 'A verificação de segurança falhou ou expirou — confirme de novo para rastrear.', /* 403 da function */
    captchaBlocked: 'Não foi possível carregar a verificação de segurança. Veja as alternativas na página.', /* E-8 (live) */
    resultPrefix: 'Consulta concluída: ', /* live region (AJ-8) */
    formReady: 'Formulário de rastreio pronto para nova consulta.',
    statusUnavailable: 'Status indisponível',
    err404: {
      icon: '🔍',
      shake: true,
      title: 'Não encontramos esse código', /* f-6 */
      body: 'Confira se os ' + CODE_LEN + ' dígitos estão exatamente como no e-mail de envio. Se o pedido acabou de ser despachado, a Jadlog pode levar algumas horas para registrar a coleta.'
    },
    err429: {
      icon: '⏳',
      shake: false, /* E-11 — SEM shake */
      title: 'Muitas consultas em sequência', /* f-7 */
      body: 'Para proteger o serviço, limitamos consultas repetidas. Aguarde um minuto e tente de novo — seu pedido continua a caminho normalmente.'
    },
    err502: {
      icon: '📡',
      shake: true,
      title: 'A Jadlog não respondeu agora', /* f-8 */
      body: 'Não foi possível completar a consulta neste momento — a instabilidade é temporária e não afeta a sua entrega. Tente de novo em instantes.'
    },
    err503: {
      /* 503 (not_configured) — indisponibilidade do NOSSO serviço: sem culpar a Jadlog */
      icon: '🛠️',
      shake: false,
      title: 'Consulta indisponível no momento',
      body: 'O serviço de rastreio está temporariamente indisponível. Tente mais tarde — ou veja o status em Minha conta → Meus pedidos.'
    }
  };

  var instances = [];
  var tsRequested = false;
  var tsTimer = null;
  /* E-17 — one-shot por PAGE LOAD: nível de módulo para que um re-init da
     section (Theme Editor) ou uma segunda instância não repitam a consulta. */
  var deepLinkUsed = false;

  function prefersReduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function telemetry(result, origin) {
    /* DP-11: NUNCA o código de rastreio no payload — só resultado e origem */
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'order_tracking_search',
      result: result,
      origin: origin === 'deeplink' ? 'deeplink' : 'manual' /* E-17 */
    });
  }

  /* E-17 — lê ?cod= (alias ?codigo=) e devolve SÓ dígitos, no máximo CODE_LEN.
     Sem param, sem dígito nenhum ou sem suporte a URL/URLSearchParams => null. */
  function readDeepLinkCode() {
    var search = window.location.search || '';
    if (search === '') return null;
    var raw = null;
    if (typeof window.URLSearchParams === 'function') {
      try {
        var params = new window.URLSearchParams(search);
        raw = params.get('cod');
        if (raw === null) raw = params.get('codigo');
      } catch (err) {
        raw = null;
      }
    }
    if (raw === null) {
      var m = /[?&](?:cod|codigo)=([^&#]*)/.exec(search);
      if (m) {
        try {
          raw = decodeURIComponent(m[1].replace(/\+/g, ' '));
        } catch (err2) {
          raw = m[1];
        }
      }
    }
    if (typeof raw !== 'string') return null;
    var digits = raw.replace(/\D/g, '').slice(0, CODE_LEN);
    return digits === '' ? null : digits;
  }

  /* E-17 — tira o param da URL sem recarregar (a página deixa de ser um deep
     link depois que o cliente pede outro rastreio). Falha silenciosa. */
  function stripDeepLinkParam() {
    if (!window.history || typeof window.history.replaceState !== 'function') return;
    if (typeof window.URL !== 'function') return;
    try {
      var url = new window.URL(window.location.href);
      if (!url.searchParams.has('cod') && !url.searchParams.has('codigo')) return;
      url.searchParams.delete('cod');
      url.searchParams.delete('codigo');
      var qs = url.searchParams.toString();
      window.history.replaceState(null, '', url.pathname + (qs !== '' ? '?' + qs : '') + url.hash);
    } catch (err) {
      /* URL malformada ou navegador sem suporte — a consulta não depende disso */
    }
  }

  /* Onload nomeado do script do Turnstile (render=explicit) */
  window.mcTrackTsOnload = function () {
    if (tsTimer) {
      clearTimeout(tsTimer);
      tsTimer = null;
    }
    instances.forEach(function (inst) {
      inst.renderCaptcha();
    });
  };

  function requestTurnstile() {
    if (tsRequested) return;
    tsRequested = true;
    if (window.turnstile) {
      /* Script já presente (outro consumidor) — render direto, sem 2ª tag */
      window.setTimeout(window.mcTrackTsOnload, 0);
      return;
    }
    var script = document.createElement('script');
    script.src = TS_SRC;
    script.async = true;
    script.defer = true;
    script.addEventListener('error', function () {
      if (tsTimer) {
        clearTimeout(tsTimer);
        tsTimer = null;
      }
      instances.forEach(function (inst) {
        inst.captchaBlocked();
      });
    });
    document.head.appendChild(script);
    tsTimer = window.setTimeout(function () {
      /* E-8 — onload não disparou em 8s */
      instances.forEach(function (inst) {
        inst.captchaBlocked();
      });
    }, TS_TIMEOUT_MS);
  }

  function formatTime(value) {
    if (typeof value !== 'string' || value === '') return '';
    var d = new Date(value);
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    } catch (err) {
      var h = ('0' + d.getHours()).slice(-2);
      var m = ('0' + d.getMinutes()).slice(-2);
      return h + ':' + m;
    }
  }

  /* Texto de um evento cru {data, status, unidade} — SÓ campos reais (AJ-7) */
  function eventText(ev) {
    if (!ev || typeof ev !== 'object') return '';
    var parts = [];
    ['data', 'status', 'unidade'].forEach(function (key) {
      if (typeof ev[key] === 'string' && ev[key] !== '') parts.push(ev[key]);
    });
    return parts.join(' · ');
  }

  function initTrack(root) {
    if (root.getAttribute('data-mc-track-init') === 'true') return;
    root.setAttribute('data-mc-track-init', 'true');

    var q = function (sel) {
      return root.querySelector(sel);
    };

    var form = q('[data-mc-track-form]');
    var input = q('[data-mc-track-input]');
    var submit = q('[data-mc-track-submit]');
    if (!form || !input || !submit) return;

    var inputError = q('[data-mc-track-input-error]');
    var slotPlaceholder = q('[data-mc-track-captcha-placeholder]');
    var slotWidget = q('[data-mc-track-captcha-widget]');
    var slotMsg = q('[data-mc-track-captcha-msg]');
    var slotFallback = q('[data-mc-track-ts-fallback]');
    var loadingEl = q('[data-mc-track-loading]');
    var resultEl = q('[data-mc-track-result]');
    var errorEl = q('[data-mc-track-error]');
    var errIcon = q('[data-mc-track-error-icon]');
    var errTitle = q('[data-mc-track-error-title]');
    var errBody = q('[data-mc-track-error-body]');
    var retryBtn = q('[data-mc-track-retry]');
    var againLink = q('[data-mc-track-again]');
    var live = q('[data-mc-track-live]');
    var codeEl = q('[data-mc-track-code]');
    var consultedEl = q('[data-mc-track-consulted-at]');
    var pillEl = q('[data-mc-track-pill]');
    var statsEl = q('[data-mc-track-stats]');
    var stat1El = q('[data-mc-track-stat1]');
    var stat1Label = q('[data-mc-track-stat1-label]');
    var stat1Value = q('[data-mc-track-stat1-value]');
    var stat2El = q('[data-mc-track-stat2]');
    var stat2Value = q('[data-mc-track-stat2-value]');
    var timelineEl = q('[data-mc-track-timeline]');
    var rawEl = q('[data-mc-track-raw-events]');

    var endpoint = root.getAttribute('data-endpoint') || '';
    var sitekey = root.getAttribute('data-sitekey') || '';
    if (endpoint === '' || sitekey === '') return;

    var token = null;
    var widgetId = null;
    var busy = false;

    /* E-17 — auto-consulta do deep link: armada no load e desarmada por edição
       manual, consulta manual ou re-consulta. O one-shot é o deepLinkUsed. */
    var autoRunArmed = false;
    /* Origem da consulta em voo, usada só na telemetria (DP-11) */
    var currentOrigin = 'manual';

    function announce(msg) {
      if (!live) return;
      /* limpa antes de setar para re-anunciar mensagens repetidas */
      live.textContent = '';
      window.setTimeout(function () {
        live.textContent = msg;
      }, 60);
    }

    function sync() {
      submit.disabled = !(input.value.length === CODE_LEN && token !== null && !busy);
    }

    function hideInputError() {
      if (inputError) inputError.hidden = true;
      form.classList.remove('is-invalid');
    }

    function showInputError() {
      /* E-2 */
      if (inputError) {
        inputError.textContent = STR.inputError;
        inputError.hidden = false;
      }
      form.classList.add('is-invalid');
      announce(STR.inputError);
    }

    function renderCaptcha() {
      if (widgetId !== null || !window.turnstile) return;
      if (slotPlaceholder) slotPlaceholder.hidden = true;
      if (slotFallback) slotFallback.hidden = true; /* recuperação pós-E-8 */
      if (slotWidget) slotWidget.classList.add('is-live');
      try {
        widgetId = window.turnstile.render(slotWidget, {
          sitekey: sitekey,
          theme: 'light',
          language: 'pt-br',
          action: 'order_tracking',
          size: slotWidget.clientWidth < 300 ? 'compact' : 'flexible',
          callback: function (t) {
            /* E-3 — habilita se o input já tem os dígitos (sync bidirecional) */
            token = t;
            if (slotMsg) slotMsg.hidden = true;
            sync();
            maybeAutoRun(); /* E-17 — o token era a última peça que faltava */
          },
          'expired-callback': function () {
            /* E-6 */
            token = null;
            sync();
            announce(STR.captchaExpired);
          },
          'error-callback': function () {
            /* E-7 */
            token = null;
            sync();
            if (slotMsg) {
              slotMsg.textContent = STR.captchaError;
              slotMsg.hidden = false;
            }
          }
        });
      } catch (err) {
        widgetId = null;
        captchaBlocked();
      }
    }

    function captchaBlocked() {
      /* E-8 — aviso honesto + links (bloco pré-renderizado pelo Liquid) */
      if (widgetId !== null) return;
      if (slotPlaceholder) slotPlaceholder.hidden = true;
      if (slotFallback) slotFallback.hidden = false;
      token = null;
      sync();
      announce(STR.captchaBlocked);
    }

    function resetCaptcha() {
      /* AJ-12/E-14 — token é single-use: SEMPRE reset na re-consulta */
      token = null;
      if (widgetId !== null && window.turnstile) {
        try {
          window.turnstile.reset(widgetId);
        } catch (err) {
          /* widget removido/expirado — o estado desabilitado já protege */
        }
      }
    }

    function scrollTo(el, block) {
      try {
        el.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: block });
      } catch (err) {
        el.scrollIntoView();
      }
    }

    function showError(spec, result) {
      loadingEl.hidden = true;
      resultEl.hidden = true;
      form.hidden = true;
      if (errIcon) {
        errIcon.textContent = spec.icon;
        errIcon.classList.remove('is-shake');
        if (spec.shake && !prefersReduced()) {
          /* reflow para re-disparar a animação em erros consecutivos */
          void errIcon.offsetWidth;
          errIcon.classList.add('is-shake');
        }
      }
      if (errTitle) errTitle.textContent = spec.title;
      if (errBody) errBody.textContent = spec.body;
      errorEl.hidden = false;
      announce(spec.title);
      telemetry(result, currentOrigin);
      scrollTo(errorEl, 'center');
    }

    function captchaRejected() {
      /* 403 da function (captcha_failed): NÃO é card de erro E-12 — volta ao
         form preservando o código digitado, turnstile.reset() (token single-use
         já consumido) e mensagem inline no slot (mesmo mecanismo do E-7).
         Copies do tema são a fonte de verdade visual: nenhum error.message do
         body é exibido — só o código HTTP roteia. */
      loadingEl.hidden = true;
      errorEl.hidden = true;
      resultEl.hidden = true;
      form.hidden = false;
      resetCaptcha();
      sync();
      if (slotMsg) {
        slotMsg.textContent = STR.captchaFailed;
        slotMsg.hidden = false;
      }
      announce(STR.captchaFailed);
      telemetry('error', currentOrigin);
      input.focus();
      scrollTo(form, 'center');
    }

    function renderTimeline(stepIdx, delivered, eventos) {
      timelineEl.innerHTML = '';
      var reduce = prefersReduced();
      for (var i = 0; i < STEPS.length; i++) {
        var stepNum = i + 1;
        var state = 'is-todo';
        if (delivered || stepNum < stepIdx) state = 'is-done';
        else if (stepNum === stepIdx) state = 'is-current';

        var item = document.createElement('div');
        item.className = 'mc-track__tl-item ' + state;

        var dot = document.createElement('span');
        dot.className = 'mc-track__tl-dot';
        if (state === 'is-done') dot.innerHTML = CHECK_SVG; /* markup estático, sem dado externo */

        var body = document.createElement('div');
        body.className = 'mc-track__tl-body';
        var title = document.createElement('div');
        title.className = 'mc-track__tl-title';
        title.textContent = STEPS[i];
        body.appendChild(title);

        /* AJ-4: passo todo = só título. AJ-7: corpo = SOMENTE campos reais do
           evento cru correspondente (posição cronológica); sem evento = título só. */
        if (state !== 'is-todo') {
          var txt = eventText(eventos[i]);
          if (txt !== '') {
            var ev = document.createElement('div');
            ev.className = 'mc-track__tl-event';
            ev.textContent = txt;
            body.appendChild(ev);
          }
        }

        item.appendChild(dot);
        item.appendChild(body);
        timelineEl.appendChild(item);
      }

      /* Stagger — zerado sob reduced-motion (AJ-9) */
      var items = timelineEl.children;
      for (var j = 0; j < items.length; j++) {
        if (reduce) {
          items[j].classList.add('is-show');
        } else {
          (function (el, k) {
            window.setTimeout(function () {
              el.classList.add('is-show');
            }, 160 + k * 230);
          })(items[j], j);
        }
      }
    }

    function renderRawEvents(eventos) {
      /* E-13 — lista simples dos eventos crus, sem os 5 passos */
      rawEl.innerHTML = '';
      for (var i = 0; i < eventos.length; i++) {
        var txt = eventText(eventos[i]);
        if (txt === '') continue;
        var li = document.createElement('li');
        li.textContent = txt;
        rawEl.appendChild(li);
      }
      rawEl.hidden = rawEl.children.length === 0;
    }

    function renderResult(code, data) {
      data = data && typeof data === 'object' ? data : {};
      var status = typeof data.status === 'string' ? data.status : '';
      var eventos = Array.isArray(data.eventos) ? data.eventos : [];
      var stepIdx = STATUS_STEP[status] || 0;
      var known = stepIdx > 0;
      var delivered = status === 'delivered';
      var previsao = typeof data.previsaoEntrega === 'string' ? data.previsaoEntrega : '';
      var lastEvent = eventos.length > 0 ? eventos[eventos.length - 1] : null;
      var lastUnit = lastEvent && typeof lastEvent.unidade === 'string' ? lastEvent.unidade : '';

      if (codeEl) codeEl.textContent = code;

      /* f-11 — "consultado às HH:MM" só com consultadoEm válido */
      if (consultedEl) {
        var when = formatTime(data.consultadoEm);
        consultedEl.textContent = when !== '' ? ' · consultado às ' + when : '';
      }

      /* Pill: entregue = verde; mapeado = laranja com o passo atual real;
         fora do mapa (E-13) = grafite com o status textual cru */
      if (pillEl) {
        pillEl.className = 'mc-track__pill';
        if (delivered) {
          pillEl.classList.add('mc-track__pill--delivered');
          pillEl.textContent = 'Entregue';
        } else if (known) {
          pillEl.classList.add('mc-track__pill--transit');
          pillEl.textContent = STEPS[stepIdx - 1];
        } else {
          pillEl.classList.add('mc-track__pill--unknown');
          pillEl.textContent = status !== '' ? status : STR.statusUnavailable;
        }
      }

      /* Stats — sempre dados reais da Jadlog; E-13 só com previsaoEntrega */
      stat1El.hidden = true;
      stat2El.hidden = true;
      if (delivered) {
        var deliveredAt = lastEvent && typeof lastEvent.data === 'string' ? lastEvent.data : '';
        if (deliveredAt !== '') {
          stat1Label.textContent = 'Entregue em';
          stat1Value.textContent = deliveredAt;
          stat1El.hidden = false;
        }
      } else if (previsao !== '') {
        stat1Label.textContent = 'Previsão de entrega';
        stat1Value.textContent = previsao;
        stat1El.hidden = false;
      }
      if (lastUnit !== '' && (known || previsao !== '')) {
        stat2Value.textContent = lastUnit;
        stat2El.hidden = false;
      }
      statsEl.hidden = stat1El.hidden && stat2El.hidden;

      /* Timeline (mapeado) × lista crua (E-13) */
      if (known) {
        rawEl.hidden = true;
        rawEl.innerHTML = '';
        timelineEl.hidden = false;
        renderTimeline(stepIdx, delivered, eventos);
      } else {
        timelineEl.hidden = true;
        timelineEl.innerHTML = '';
        renderRawEvents(eventos);
      }

      loadingEl.hidden = true;
      errorEl.hidden = true;
      resultEl.hidden = false;
      announce(STR.resultPrefix + (pillEl ? pillEl.textContent : ''));
      telemetry('found', currentOrigin); /* E-5/E-9 e E-13 com 200 contam found */
      scrollTo(resultEl, 'start');
    }

    function query(code, origin) {
      if (busy) return; /* single-flight */
      busy = true;
      currentOrigin = origin === 'deeplink' ? 'deeplink' : 'manual';
      autoRunArmed = false; /* E-17 — uma consulta já saiu; nada mais é automático */
      var usedToken = token;
      token = null; /* token Turnstile é single-use — consumido nesta consulta */
      sync();
      hideInputError();
      form.hidden = true;
      errorEl.hidden = true;
      resultEl.hidden = true;
      loadingEl.hidden = false;
      announce(STR.loading);

      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = controller
        ? window.setTimeout(function () {
            controller.abort();
          }, FETCH_TIMEOUT_MS)
        : null;

      fetch(endpoint, {
        method: 'POST',
        credentials: 'omit',
        referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ codigo: code, captchaToken: usedToken }),
        signal: controller ? controller.signal : undefined
      })
        .then(function (res) {
          if (res.status === 200) {
            return res
              .json()
              .then(function (data) {
                renderResult(code, data);
              })
              .catch(function () {
                showError(STR.err502, 'error');
              });
          }
          if (res.status === 404) {
            showError(STR.err404, 'not_found'); /* E-10 */
            return;
          }
          if (res.status === 429) {
            showError(STR.err429, 'rate_limited'); /* E-11 */
            return;
          }
          if (res.status === 403) {
            captchaRejected(); /* captcha_failed — não é falha da Jadlog */
            return;
          }
          if (res.status === 503) {
            showError(STR.err503, 'error'); /* not_configured — serviço próprio indisponível */
            return;
          }
          showError(STR.err502, 'error'); /* E-12 — 5xx da Jadlog/inesperado */
        })
        .catch(function () {
          showError(STR.err502, 'error'); /* E-12 — rede/timeout/abort */
        })
        .then(function () {
          if (timer) window.clearTimeout(timer);
          busy = false;
          loadingEl.hidden = true;
          sync();
        });
    }

    /* E-17 — dispara a consulta do deep link assim que TODAS as condições
       existirem (código completo + token do captcha + nada em voo). */
    function maybeAutoRun() {
      if (!autoRunArmed || deepLinkUsed || busy) return;
      if (token === null) return;
      if (input.value.length !== CODE_LEN) return;
      deepLinkUsed = true; /* one-shot por page load */
      query(input.value, 'deeplink');
    }

    function resetToForm(keepCode) {
      /* E-14 — re-consulta */
      autoRunArmed = false;
      resultEl.hidden = true;
      errorEl.hidden = true;
      loadingEl.hidden = true;
      form.hidden = false;
      if (!keepCode) {
        input.value = '';
        /* "Rastrear outro pedido": a URL deixa de carregar o código antigo */
        stripDeepLinkParam();
      }
      hideInputError();
      resetCaptcha();
      sync();
      input.focus();
      scrollTo(form, 'center');
      announce(STR.formReady);
    }

    /* ── Listeners ── */
    input.addEventListener('input', function () {
      var digits = input.value.replace(/\D/g, '').slice(0, CODE_LEN);
      if (input.value !== digits) input.value = digits;
      autoRunArmed = false; /* E-17 — edição manual cancela a auto-consulta */
      hideInputError();
      sync();
    });

    input.addEventListener('keydown', function (e) {
      /* E-2 alcançável mesmo com o submit desabilitado (Enter no input) */
      if (e.key === 'Enter' && submit.disabled) {
        e.preventDefault();
        if (input.value.length !== CODE_LEN) showInputError();
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (input.value.length !== CODE_LEN) {
        /* E-2 */
        showInputError();
        input.focus();
        return;
      }
      if (token === null) return; /* AJ-6 — o botão já está desabilitado; guarda extra */
      query(input.value, 'manual');
    });

    if (againLink) {
      againLink.addEventListener('click', function (e) {
        e.preventDefault();
        resetToForm(false);
      });
    }
    if (retryBtn) {
      retryBtn.addEventListener('click', function () {
        /* mantém o código digitado para a nova tentativa (turnstile.reset SEMPRE) */
        resetToForm(true);
      });
    }

    /* ── E-17 — deep link ?cod= / ?codigo= ──
       Prefill sempre sanitizado (o valor da URL nunca vai ao DOM cru).
       Código completo => arma a auto-consulta (dispara quando o token chegar).
       Código parcial => prefill parcial + erro inline E-2, SEM auto-run: o
       cliente vê o que veio e corrige, em vez de uma consulta fadada ao 404. */
    var deepCode = deepLinkUsed ? null : readDeepLinkCode();
    if (deepCode !== null) {
      input.value = deepCode;
      if (deepCode.length === CODE_LEN) {
        autoRunArmed = true;
      } else {
        showInputError();
      }
    }

    sync();

    var inst = { renderCaptcha: renderCaptcha, captchaBlocked: captchaBlocked };
    instances.push(inst);
    requestTurnstile();
    if (window.turnstile) renderCaptcha();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-mc-track]');
    for (var i = 0; i < roots.length; i++) initTrack(roots[i]);
  }

  initAll(document);

  /* Theme Editor: re-render da section */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });
})();
